import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function CtaPair({ onDark = false, healthLabel = "Get My Free Health Score →", align = "center" }) {
  const outline = onDark
    ? "border-white/40 bg-transparent text-white hover:bg-white/10 hover:text-white"
    : "border-brand-navy bg-transparent text-brand-navy hover:bg-brand-navy/5";
  const justify = align === "center" ? "justify-center" : "justify-start";
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${justify}`}>
      <Button asChild size="lg" className="bg-brand-teal hover:bg-brand-teal/90 text-white font-semibold">
        <Link to="/health-score">{healthLabel}</Link>
      </Button>
      <Button asChild size="lg" variant="outline" className={`font-semibold ${outline}`}>
        <Link to="/validation-intake">Book a Free Compliance Review</Link>
      </Button>
    </div>
  );
}